import { render, staticRenderFns } from "./TariffedCard.vue?vue&type=template&id=5bb75f43&scoped=true"
import script from "./TariffedCard.vue?vue&type=script&lang=js"
export * from "./TariffedCard.vue?vue&type=script&lang=js"
import style0 from "./TariffedCard.vue?vue&type=style&index=0&id=5bb75f43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb75f43",
  null
  
)

export default component.exports